import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import { Button, Grid, TextareaAutosize } from "@material-ui/core";
import Backbutton from "../../Backbutton";

import { Formik } from "formik";
import * as yup from "yup";
import axios from "axios";
import { connect } from "react-redux";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core//MenuItem";
import Select from "@material-ui/core/Select";
import { CircularProgress } from '@material-ui/core';

import SweetAlert from "react-bootstrap-sweetalert";

let schema = yup.object({
  categoryalias: yup.string().required("Category Alias is Required"),
  categoryname: yup
    .string()
    .required("Category name is required")
    .typeError(""),
});

function CategoryEdit({ server, history, access_token, role, location }) {

  const [errortext, seterrortext] = useState("");
  const [alert, setAlert] = useState(null);
  const [onLoading, setOnLoading] = React.useState(false);

  useEffect(() => {

    if (role?.id !== 1) {
      if (role?.id === 2) {
        history.push("/Distributer");
      }
      if (role?.id === 3) {
        history.push("/Retailer");
      }
      if (role?.id === 4) {
        history.push("/Games");
      }
    }
  }, []);

  const hideAlert = () => {
    setAlert(null);
  };

  const added = () => {
    setAlert(
      <SweetAlert success title="Added" onConfirm={hideAlert}>
        Category has been updated
      </SweetAlert>
    );

    history.push('/Category')

  };

  const editValue = (values, resetForm) => {

    setOnLoading(true);

    const data = {
      alias: values.categoryalias,
      name: values.categoryname,
      sort_order: values.sortOrder,
      presentation_type: values.presentation_type,
      _method: "put",
    };

    const config = {
      headers: { Authorization: `Bearer ${access_token}` },
    };

    axios
      .post(server + "api/category/" + location.state[0].id, data, config)
      .then((response) => {
        
        added();
        resetForm();
        seterrortext("");
        setOnLoading(false);
      })
      .catch((error) => {
        const errormessage = error.response.data.errors.alias[0];
        seterrortext(errormessage);
      });
  };

  return (
    <div className="grayBackgroundBox">
      {alert}
      <div className="card container">
        <Formik
          initialValues={{
            categoryname: location?.state[0]?.name,
            categoryalias: location?.state[0]?.alias,
            sortOrder: location?.state[0]?.sort_order,
            presentation_type: location?.state[0]?.presentation_type,
          }}
          validationSchema={schema}
          onSubmit={(values, { resetForm }) => {
            console.log(values);
            editValue(values, resetForm);
          }}
        >
          {({
            values,
            handleBlur,
            handleChange,
            handleSubmit,
            errors,
            touched,
            isSubmitting,
            isValid,
          }) => (
            <form className="container" onSubmit={handleSubmit}>
              <div style={{ textAlign: "start" }}>
                <Backbutton />
              </div>
              <div className="title">Edit Category</div>
              <div>
                <div className="row">
                  <div className="col-12 col-md-6 inputFieldContainer">
                    <TextField
                      className="inputField"
                      id="standard-basic"
                      label="Category Name*"
                      name="categoryname"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.categoryname}
                    />
                    {errors.categoryname && touched.categoryname && (
                      <p style={{ color: "red" }}>{errors.categoryname}</p>
                    )}
                  </div>
                  <div className="col-12 col-md-6 inputFieldContainer">
                    <TextField
                      className="inputField"
                      id="standard-basic"
                      label="Category Slug*"
                      name="categoryalias"
                      onChange={handleChange}
                      onBlur={handleBlur}                      
                      value={values.categoryalias}
                    />
                    {errors.categoryalias && touched.categoryalias && (
                      <p style={{ color: "red" }}>{errors.categoryalias}</p>
                    )}
                  </div>


                  <div className="col-12 col-md-6 inputFieldContainer">
                    <TextField
                      className="inputField"
                      id="standard-basic"
                      label="Sort order*"
                      type="number"
                      name="sortOrder"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.sortOrder}
                    />
                    {errors.sortOrder && touched.sortOrder && (
                      <p style={{ color: "red" }}>{errors.sortOrder}</p>
                    )}
                    {errortext && <p style={{ color: "red" }}>{errortext}</p>}
                  </div>


                  <FormControl fullWidth style={{marginTop:30}}> 
                          <InputLabel id="demo-simple-select-standard-label">
                            Presentation Type*
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-standard-label"
                            id="demo-multiple-name"
                            value={values.presentation_type}
                            onChange={handleChange}
                            label="Presentation Type*"
                            name="presentation_type"
                          >

                            <MenuItem value="direct">Direct</MenuItem>
                            <MenuItem value="color-based">Color Based</MenuItem>
                            <MenuItem value="fitment-based">Fitment Based</MenuItem>
                            
                          </Select>
                 </FormControl>
            
                </div>
              </div>
              <div className="text-center mt-5" style={{ textAlign: "center" }}>
                <Button
                  className="formSubmit"
                  variant="contained"
                  type="submit"
                  color="primary"
                  disabled={!isValid}
                  style={{backgroundColor:'#F05225'}}
                  disableElevation
                >
          {onLoading ? <CircularProgress style={{color:'white'}} /> : "Save Category"}

                </Button>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  server: state.auth.server,
  access_token: state.auth.access_token,
  role: state.auth.role[0],
});

export default connect(mapStateToProps, {})(CategoryEdit);
